import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MaterialModule } from 'jk-service';
import { SysuserService, PageKind, entityState, UiModeType, } from 'jk-service';
import { templateUrlConfigSys } from '../_service_sys';
import { jkSingleComponent, JkaggridComponent } from 'jk-advcom';
import { JackBaseComponentModule } from 'jk-service';
import { SysuserEditComponent } from '../sysuser-edit/sysuser-edit.component';
import { AdvComModule } from 'jk-advcom';


@Component({
  selector: 'app-admi10',
  standalone: true,
  providers: [],
  imports: [
    MaterialModule,
    JackBaseComponentModule,
    AdvComModule,
  ],
  templateUrl: './admi10Pkg.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: [],
})
export class Admi10PkgComponent extends jkSingleComponent implements OnInit {
  override _programId = 'admi10';
  constructor() {
    super();
    this.srv = new SysuserService();
    this.uiMode = UiModeType.dialog;
    this.title = '登入者代號建立作業';
    this.gridInitOpt = { programId: this.programId, sortField: 'UserID', sort: 'asc', defaultSort: null, pageKind: this.pageKind };
    this.qbeConfig.addField = 'UserName,CUSTOMER';
    this.qbeConfig.addWhere = '';
    this.masterEditPage = SysuserEditComponent;


    this.constructorInit();
  }




}
